export const downloadBase64 = (b64: string, fileName: string) => {
  const data = window.atob(b64)
  const arrayBuff = new ArrayBuffer(data.length)
  const array = new Uint8Array(arrayBuff)
  for (let i = 0; i < data.length; i++) {
    array[i] = data.charCodeAt(i)
  }
  const blob = new Blob([array], { type: 'application/octet-stream' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
